// hooks/useAdmin.js
import { useContext } from 'react';
import { AdminContext } from '../context/AdminContext';

/**
 * Custom hook to access admin data and functions
 * @returns {Object} Admin context value
 */
export const useAdmin = () => {
  const context = useContext(AdminContext);
  
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  
  return context;
};

export default useAdmin;